// extracted by mini-css-extract-plugin
module.exports = {"form":"ScanCodeInput_form__HUnpL","laser":"ScanCodeInput_laser__mcE1w","submit":"ScanCodeInput_submit__mQy7I","instructions":"ScanCodeInput_instructions__Jt43G"};